import { HTMLProps, MouseEvent, MouseEventHandler, ReactElement, useState } from 'react'
import { IconButton, Menu, MenuItem, Typography } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'

interface Props extends HTMLProps<HTMLButtonElement> {
  options: { label: string; link?: string; onClick?: MouseEventHandler }[]
  className?: string
  preventEvent?: boolean
  icon?: ReactElement
}

export default function Dropdown({ className, options, icon }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        className={className}
        onClick={handleClick}
      >
        {icon ?? <MoreVertIcon />}
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {options.map((option, index) => (
          <MenuItem
            key={option.label}
            component={option.link ? 'a' : 'div'}
            href={option.link ?? ''}
            divider={index !== options.length - 1}
            onClick={async (e: MouseEvent) => {
              await option.onClick?.(e)
              handleClose()
            }}
          >
            <Typography color={'icon.main'}>{option.label}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}
